<template>
  <colored-popup :class="'warning'" :closeAction="closePopup">

    <template v-slot:top-content>
      <div>
        <div>
          <img :src="require('@/assets/wine-and-dine/trial-explanation-star.svg')"/>
        </div>
        <div class="title">
          <div>חודש התנסות חינם</div>
          <div>לנרשמים עכשיו!</div>
        </div>
      </div>
    </template>

    <template v-slot:bottom-content>
      <div class="popup-bottom-content">
        <div class="item first">
          <div><img :src="require('@/assets/icons/v-outline-filled-pink.svg')"/></div>
          <div class="content">35 ימי ניסיון בחינם ובלי התחייבות</div>
        </div>
        <div class="item">
          <div><img :src="require('@/assets/icons/v-outline-filled-pink.svg')"/></div>
          <div class="content">בסוף תקופת הניסיון אפשר לבחור אם להמשיך למנוי בתשלום של ₪45 לחודש</div>
        </div>
        <div class="item">
          <div><img :src="require('@/assets/icons/v-outline-filled-pink.svg')"/></div>
          <div class="content">לא צריך להוסיף אמצעי תשלום עד סוף תקופת הניסיון</div>
        </div>
      </div>
    </template>

  </colored-popup>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import { mapActions } from 'vuex';

export default {
  name: 'TrialExplanationModal',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
  },
  created() {
    Segment.trackUserGot('TrialExplanationShown');
    Segment.trackUserGotToPixel('TrialExplanationShown');
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),

    closePopup() {
      Segment.trackUserInteraction('TrialExplanationClosed');
      Segment.trackUserInteractionToPixel('TrialExplanationClosed');
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';
.title {
  margin-top: 20px;
  font-size: 24px;
  line-height: 32px;
  color: $riseup_black;
  font-family: SimplerPro;
  font-weight: bold;
}

.item {
  display: flex;
  flex-direction: row;

  &:not(.first) {
    margin-top: 30px;
  }
}

.content {
  text-align: right;
  font-size: 18px;
  line-height: 26px;
  color: $riseup_black;
  font-family: SimplerPro;
  margin-right: 15px;
}

.popup-bottom-content {
  margin: 20px 0px;
}
</style>
